import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('en-IN', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
};

export const formatDateTime = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleString('en-IN', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};

export const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
};

// Lead status progression (Legacy + New Workflow)
export const LEAD_STATUSES = [
    { key: 'lead', label: 'Lead', color: 'blue' },
    { key: 'opportunity', label: 'Opportunity', color: 'purple' },
    { key: 'application', label: 'Application', color: 'amber' },
    { key: 'assigned_to_counsellor', label: 'Assigned to Counsellor', color: 'indigo' },
    { key: 'for_approval', label: 'For Approval', color: 'orange' },
    { key: 'review_provided', label: 'Review Provided', color: 'sky' },
    { key: 'send_for_billing', label: 'Send for Billing', color: 'pink' },
    { key: 'admission_fee_paid', label: 'Admission Fee Paid', color: 'teal' },
    { key: 'fees_paid', label: 'Fees Paid', color: 'cyan' },
    { key: 'enrolled', label: 'Enrolled', color: 'green' },
    { key: 'not_interested', label: 'Not Interested', color: 'rose' },
    { key: 'invalid_lead', label: 'Invalid Lead', color: 'gray' },
    { key: 'not_responding', label: 'Not Responding', color: 'slate' }
];

// Lead Temperature
export const LEAD_TEMPERATURES = [
    { key: 'hot', label: 'Hot', color: 'red', icon: 'Flame' },
    { key: 'warm', label: 'Warm', color: 'orange', icon: 'Sun' },
    { key: 'cold', label: 'Cold', color: 'blue', icon: 'Snowflake' }
];

// User Roles
export const USER_ROLES = [
    { key: 'admin', label: 'Administrator' },
    { key: 'manager', label: 'Manager' },
    { key: 'agent', label: 'Field Agent' },
    { key: 'reception_desk', label: 'Reception Desk' },
    { key: 'counsellor', label: 'Counsellor' },
    { key: 'billing_agent', label: 'Billing Agent' },
    { key: 'management', label: 'Management' },
    { key: 'secretary', label: 'Secretary' },
    { key: 'chairman', label: 'Chairman' }
];

// Get role display name
export const getRoleDisplayName = (role) => {
    const found = USER_ROLES.find(r => r.key === role);
    return found ? found.label : role?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) || 'Unknown';
};

export const CALL_OUTCOMES = [
    { key: 'contacted', label: 'Contacted', color: 'indigo' },
    { key: 'callback', label: 'Callback', color: 'orange' },
    { key: 'not_interested', label: 'Not Interested', color: 'red' }
];

export const getStatusColor = (status) => {
    const colors = {
        new: 'status-new',
        lead: 'status-lead',
        opportunity: 'status-opportunity',
        application: 'status-application',
        assigned_to_counsellor: 'status-assigned_to_counsellor',
        for_approval: 'status-for_approval',
        review_provided: 'status-review_provided',
        send_for_billing: 'status-send_for_billing',
        admission_fee_paid: 'status-admission_fee_paid',
        fees_paid: 'status-fees_paid',
        enrolled: 'status-enrolled',
        contacted: 'status-contacted',
        callback: 'status-callback',
        not_interested: 'status-not_interested',
        interested: 'status-opportunity'
    };
    return colors[status] || 'status-new';
};

export const getStatusIndex = (status) => {
    const index = LEAD_STATUSES.findIndex(s => s.key === status);
    return index >= 0 ? index : 0;
};

export const getCallStatusColor = (status) => {
    const colors = {
        connected: 'call-connected',
        no_answer: 'call-no_answer',
        busy: 'call-busy',
        wrong_number: 'bg-gray-100 text-gray-600 ring-1 ring-inset ring-gray-200',
        interested: 'bg-green-100 text-green-600 ring-1 ring-inset ring-green-200',
        not_interested: 'bg-red-100 text-red-600 ring-1 ring-inset ring-red-200',
        callback: 'bg-orange-100 text-orange-600 ring-1 ring-inset ring-orange-200'
    };
    return colors[status] || 'bg-slate-100 text-slate-600 ring-1 ring-inset ring-slate-200';
};

export const getSourceIcon = (sourceType) => {
    switch (sourceType) {
        case 'instagram':
            return 'Instagram';
        case 'web':
            return 'Globe';
        case 'campaign':
            return 'Megaphone';
        case 'facebook':
            return 'Facebook';
        case 'referral':
            return 'Users';
        default:
            return 'Link';
    }
};

export const capitalize = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).replace(/_/g, ' ');
};

export const truncate = (str, length = 30) => {
    if (!str) return '';
    return str.length > length ? str.substring(0, length) + '...' : str;
};

export const formatPhone = (phone) => {
    if (!phone) return '';
    return phone.replace(/(\+91)(\d{5})(\d{5})/, '$1 $2 $3');
};

export const getWhatsAppLink = (phone) => {
    const cleaned = phone.replace(/\D/g, '');
    return `https://wa.me/${cleaned}`;
};

export const getConversionRatioClass = (ratio) => {
    if (ratio >= 30) return 'ratio-good';
    if (ratio >= 15) return 'ratio-medium';
    return 'ratio-low';
};
